import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { ProductResultLayoutComponentsProviderComponentBase, RenderInProductResultLayoutDirective } from 'products-ui';
import { PunchoutItemPricingComponentStore } from 'punchout-data';
import { LeadTimeNotificationChipComponent } from '../lead-time-notification-chip/lead-time-notification-chip.component';
import { PunchoutPromoRibbonComponent } from '../promo-ribbon/punchout-promo-ribbon.component';

@Component({
  selector: 'ideal-punchout-product-result-layout-components-provider',
  standalone: true,
  providers: [PunchoutItemPricingComponentStore],
  imports: [RenderInProductResultLayoutDirective, PunchoutPromoRibbonComponent, LeadTimeNotificationChipComponent],
  templateUrl: './punchout-product-result-layout-components-provider.component.html',
  styleUrl: './punchout-product-result-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PunchoutProductResultLayoutComponentsProviderComponent extends ProductResultLayoutComponentsProviderComponentBase {
  protected readonly store = inject(PunchoutItemPricingComponentStore);
  protected readonly stockLocation = computed(() => this.store.itemStock()?.stockLocation);
  constructor() {
    super();
    effect(() => this.store.selectItemById(this.id()?.toString()));
    effect(() => this.store.selectItemStockById(this.id()?.toString()));
  }
}
